import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetOdontoProviderAddress,
	GetOdontoProviderAddressModel,
	OdontoProviderAddressParams,
} from 'domain/usecases';

export class RemoteGetOdontoProviderAddress implements GetOdontoProviderAddress {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetOdontoProviderAddressModel>,
	) {}

	async get(params: OdontoProviderAddressParams): Promise<GetOdontoProviderAddressModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
